import { useState, useRef, useEffect } from 'react';
import { Pencil } from 'lucide-react';
import EditStatusOptionsModal from '../EditStatusOptionsModal';

export default function StatusCell({ value, column, statusOptions = [], onChange, readOnly = false }) {
  const [open, setOpen] = useState(false);
  const [editorOpen, setEditorOpen] = useState(false);
  const ref = useRef(null);

  const selected = statusOptions.find((o) => o.id === value?.id || o.label === value?.label || o.label === value);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const handleSelect = (option) => {
    // Formato canônico {id,label} (M3c) — permite ao restante da UI comparar
    // por id em vez de label (StatusCell/BoardTable/GroupFooter). O backend
    // já aceita string crua por compatibilidade, mas passa a gravar sempre
    // {id,label} a partir daqui.
    onChange({ id: option.id, label: option.label });
    setOpen(false);
  };

  const handleClear = () => {
    onChange(null);
    setOpen(false);
  };

  return (
    <div className="relative w-full h-full" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        disabled={readOnly}
        className={`w-full h-full flex items-center justify-center transition-colors min-h-[40px] disabled:cursor-default`}
        style={selected ? { backgroundColor: selected.color, color: '#fff' } : undefined}
      >
        {selected ? (
          <span className="cell-badge-text font-semibold truncate">{selected.label}</span>
        ) : (
          <span />
        )}
      </button>

      {open && !readOnly && (
        <div className="absolute top-full left-0 z-50 mt-1 w-[358px] bg-card border border-border rounded-lg shadow-xl py-2.5 overflow-hidden">
          <div className="grid grid-cols-2 gap-2.5 px-2.5 pb-2.5">
            {statusOptions.map((option) => (
              <button
                key={option.id}
                onClick={() => handleSelect(option)}
                className="rounded px-2.5 py-2.5 text-[13px] font-semibold text-white hover:opacity-90 transition-opacity truncate"
                style={{ backgroundColor: option.color }}
                title={option.label}
              >
                {option.label}
              </button>
            ))}
            <button
              onClick={handleClear}
              className="rounded px-2.5 py-2.5 text-[13px] font-semibold text-text-secondary bg-white/5 hover:bg-white/10 transition-colors"
            >
              —
            </button>
          </div>
          <div className="border-t border-border/50 pt-1">
            <button
              onClick={() => { setOpen(false); setEditorOpen(true); }}
              className="w-full flex items-center gap-2 px-3 py-2 text-xs text-text-primary hover:bg-white/5 transition-colors"
            >
              <Pencil className="w-3.5 h-3.5" />
              Editar etiquetas
            </button>
          </div>
        </div>
      )}

      {editorOpen && column && (
        <EditStatusOptionsModal
          column={column}
          options={statusOptions}
          onClose={() => setEditorOpen(false)}
        />
      )}
    </div>
  );
}
